import { render } from "./MidBatchApiFileConfigurationCard.vue?vue&type=template&id=c67f6920&scoped=true&ts=true"
import script from "./MidBatchApiFileConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./MidBatchApiFileConfigurationCard.vue?vue&type=script&lang=ts"

import "./MidBatchApiFileConfigurationCard.vue?vue&type=style&index=0&id=c67f6920&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67f6920"]])

export default __exports__